import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ANALYTICS_CONSENT_EVENT, ANALYTICS_CONSENT_KEY } from '../privacy/CookieConsent';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default function GoogleAnalytics() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);
  const [hasConsent, setHasConsent] = useState(
    () => window.localStorage.getItem(ANALYTICS_CONSENT_KEY) === 'granted',
  );
  const measurementId = import.meta.env.VITE_REVIEW_MODE === 'true' ? '' : (import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-C1ZP6N7JBF');

  useEffect(() => {
    const handleConsent = (event: Event) => {
      setHasConsent((event as CustomEvent<string>).detail === 'granted');
    };
    window.addEventListener(ANALYTICS_CONSENT_EVENT, handleConsent);
    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, handleConsent);
  }, []);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    if (!hasConsent || !window.gtag || lastPath.current === pagePath) return;

    const timeout = window.setTimeout(() => {
      if (lastPath.current === pagePath) return;
      lastPath.current = pagePath;
      window.gtag?.('event', 'page_view', {
        send_to: measurementId,
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 0);

    return () => window.clearTimeout(timeout);
  }, [hasConsent, location.pathname, location.search, measurementId]);

  return null;
}
